import { Link } from "react-router-dom";
import { DESTINATIONS } from "@/pages/public/destinations/data";

const PICKS = ["chikmagalur", "coorg", "agumbe"] as const;

export default function TopPicks() {
  const picks = PICKS.map((id) => DESTINATIONS.find((d) => d.id === id)).filter(Boolean);

  return (
    <section className="relative w-full py-16 md:py-24 bg-background-100 overflow-hidden">
      <div className="w-full px-4 md:px-8 max-w-7xl mx-auto">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.2em] uppercase text-accent-600">
            <i className="ri-fire-line"></i> Top 3 Picks
          </span>
          <h2 className="font-heading text-3xl md:text-5xl text-foreground-950 mt-4 leading-tight">
            The <span className="italic text-primary-700">Most Loved</span> Destinations Right Now
          </h2>
          <p className="text-foreground-600 text-sm md:text-base mt-4 leading-relaxed">
            These three hill escapes are where our investors are building first — proven demand,
            stunning scenery and the strongest returns in the portfolio.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mt-10 md:mt-14">
          {picks.map((dest) => (
            <article
              key={dest!.id}
              className="group relative flex flex-col rounded-2xl bg-background-50 border border-background-200 overflow-hidden hover:border-primary-300 hover:-translate-y-0.5 transition-all duration-300"
            >
              <div className="relative h-56 w-full overflow-hidden">
                <img
                  src={dest!.image}
                  alt={`${dest!.name} — ${dest!.tagline}, ${dest!.state}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
                <span className="absolute bottom-4 left-4 rounded-full bg-accent-100 text-accent-900 text-xs font-semibold px-3 py-1.5 flex items-center gap-1.5">
                  <i className="ri-line-chart-line"></i> Est. ROI {dest!.roi}
                </span>
              </div>

              <div className="p-5 md:p-6 flex flex-col flex-1">
                <div className="flex items-center gap-2 text-[11px] font-semibold tracking-wide uppercase text-foreground-500">
                  <i className="ri-map-pin-2-line text-primary-600"></i>
                  {dest!.region} · {dest!.state}
                </div>
                <h3 className="font-heading text-xl md:text-2xl text-foreground-950 mt-2">
                  {dest!.name}
                </h3>
                <p className="text-sm text-accent-600 italic mt-1">{dest!.tagline}</p>
                <p className="text-sm text-foreground-600 mt-3 leading-relaxed flex-1">
                  {dest!.summary.slice(0, 140)}...
                </p>

                <div className="mt-4 grid grid-cols-2 gap-3">
                  <div className="rounded-xl bg-background-100 border border-background-200 py-2.5 text-center">
                    <p className="text-xs font-bold text-foreground-950">{dest!.startPrice}</p>
                    <p className="text-[10px] text-foreground-600">Entry</p>
                  </div>
                  <div className="rounded-xl bg-background-100 border border-background-200 py-2.5 text-center">
                    <p className="text-xs font-bold text-foreground-950">{dest!.peakSeason}</p>
                    <p className="text-[10px] text-foreground-600">Peak Season</p>
                  </div>
                </div>

                <Link
                  to="/destinations"
                  className="mt-5 inline-flex items-center justify-center gap-2 text-sm font-semibold whitespace-nowrap rounded-full border border-primary-600 text-primary-700 px-4 py-2.5 hover:bg-primary-600 hover:text-background-50 transition-colors"
                >
                  Explore {dest!.name}
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/destinations"
            className="inline-flex items-center gap-2 text-sm font-semibold whitespace-nowrap rounded-full bg-primary-600 text-background-50 px-6 py-3 hover:bg-primary-700 transition-colors"
          >
            View All 10 Destinations
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}